import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { polymorphicFactory } from "./auth-service-tools249.js";
import { Input } from "./auth-service-tools299.js";
import { useInputProps } from "./auth-service-tools308.js";
const defaultProps = {
  __staticSelector: "InputBase",
  withAria: true
};
const InputBase = polymorphicFactory((props, ref) => {
  const {
    inputProps,
    wrapperProps,
    ...others
  } = useInputProps("InputBase", defaultProps, props);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Input.Wrapper, { ...wrapperProps,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Input, { ...inputProps,
      ...others,
      ref
    })
  });
});
InputBase.classes = { ...Input.classes,
  ...Input.Wrapper.classes
};
InputBase.displayName = "@mantine/core/InputBase";
export { InputBase };